import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { Form, Modal } from "reactstrap";
import Swal from 'sweetalert2';
import { Controller, useForm } from "react-hook-form";

import API from '../../API';
import { DateFormat, DateFormatJSON, NumberFormat, CleanMobile, TimeFormat, DateThaiFormat, RootURL } from '../../Utils/Function';
import { SearchSubDistrict, SearchCustomer } from '../../Utils/Search';
import { QuotationType, QuotationTypeName } from '../../Utils/Status';
import { ProductView } from '..';
import parse from 'html-react-parser'
import moment from 'moment';
import AsyncSelect from 'react-select/async';

import { ThaiDatePicker } from "thaidatepicker-react";
import "react-datepicker/dist/react-datepicker.css";
import NewWindow from 'react-new-window'
import PromotionItem from '../Promotion/PromotionItem';

const QuotationEventCreate = forwardRef((props, ref) => {
    const { register, handleSubmit, watch, reset, getValues, setValue, control, formState: { errors } } = useForm();
    const [_Customer, setCustomer] = useState(null);

    const [ModalState, setModalState] = useState(false);
    const [EventDate, setEventDate] = useState(null);
    const [_StandbyTime, setStandbyTime] = useState(null);
    const [_StartTime, setStartTime] = useState(null);
    const [_EndTime, setEndTime] = useState(null);
    const [AccountType, setAccountType] = useState(0);
    const [_Invoice, setInvoice] = useState(0);
    const [_LocationDetail, setLocationDetail] = useState('');

    const [_MapPickerOpen, setMapPickerOpen] = useState(false);
    const [_PickerLat, setPickerLat] = useState('');
    const [_PickerLon, setPickerLon] = useState('');

    useEffect(() => {
        return () => { }
    }, []);

    useImperativeHandle(ref, () => ({
        Show(Customer) {
            console.log(Customer);
            _ClearValue();
            setCustomer(Customer);
            setValue('ContactName', Customer.Name);
            setValue('MobileMain', Customer.Mobile);
            setModalState(true);
        }
    }));

    const _ClearValue = () => {
        reset();


    }

    const _CloseModel = () => {
        setModalState(false);
        if (props.callback != undefined) {
            try { props.callback(); } catch (e) { }
        }
    }

    const _OpenMapPicker = () => {
        const cur = getValues('EventLocation');
        if (cur) {
            const p = cur.split(',');
            if (p.length === 2) { setPickerLat(p[0].trim()); setPickerLon(p[1].trim()); }
        } else {
            setPickerLat(''); setPickerLon('');
        }
        setMapPickerOpen(true);
    }

    const _ConfirmLocation = () => {
        if (_PickerLat && _PickerLon) {
            setValue('EventLocation', `${_PickerLat},${_PickerLon}`);
        }
        setMapPickerOpen(false);
    };

    const _GetCurrentLocation = () => {
        if (!navigator.geolocation) {
            Swal.fire({ icon: 'error', title: 'เบราว์เซอร์ไม่รองรับการระบุตำแหน่ง' });
            return;
        }
        Swal.showLoading();
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                Swal.close();
                setPickerLat(pos.coords.latitude.toFixed(6));
                setPickerLon(pos.coords.longitude.toFixed(6));
            },
            () => {
                Swal.close();
                Swal.fire({ icon: 'error', title: 'ไม่สามารถรับตำแหน่งได้', text: 'โปรดอนุญาตการเข้าถึงตำแหน่งในเบราว์เซอร์' });
            }
        );
    };

    const _ParseMapsURL = (url) => {
        if (!url) return;
        // google.com/maps/@lat,lon,zoom or /maps/place/.../@lat,lon
        let m = url.match(/@([-\d.]+),([-\d.]+)/);
        if (m) { setPickerLat(m[1]); setPickerLon(m[2]); return; }
        // maps.google.com/maps?q=lat,lon
        m = url.match(/[?&]q=([-\d.]+),([-\d.]+)/);
        if (m) { setPickerLat(m[1]); setPickerLon(m[2]); return; }
        // plain "lat,lon"
        m = url.match(/^([-\d.]+)\s*,\s*([-\d.]+)$/);
        if (m) { setPickerLat(m[1]); setPickerLon(m[2]); }
    };

    const _NewEvent = async () => {
        if (EventDate === null || EventDate === undefined || EventDate === '') {
            Swal.fire({ icon: 'error', title: 'โปรดระบุวันที่จัดงาน' });
            return;
        }
        if (_LocationDetail === null || _LocationDetail === undefined || _LocationDetail === '') {
            Swal.fire({ icon: 'error', title: 'โปรดระบุสถานที่จัดงาน' });
            return;
        }
        if (getValues('EventAddress') === null || getValues('EventAddress') === undefined || getValues('EventAddress') === '') {
            Swal.fire({ icon: 'error', title: 'โปรดระบุที่อยู่สถานที่จัดงาน' });
            return;
        }
        const _DateStr = DateFormatJSON(EventDate, false);
        const _ReqBody = {
            CustomerID: _Customer?.CustomerID || null,
            EventDate: _DateStr,
            StandbyTime: (_StandbyTime ? _DateStr + ' ' + _StandbyTime : null),
            EventStart: (_StartTime ? _DateStr + ' ' + _StartTime : null),
            EventEnd: (_EndTime ? _DateStr + ' ' + _EndTime : null),
            LocationDetail: _LocationDetail || null,
            MobileMain: CleanMobile(getValues('MobileMain')) || null,
            MobileBackup: CleanMobile(getValues('MobileBackup')) || null,
            ContactName: getValues('ContactName') || null,
            AccountType: AccountType,
            InvoiceStatus: _Invoice,
            NoteFacebook: getValues('NoteFacebook') || null,
            NoteLine: getValues('NoteLine') || null,
            NoteCalendar: getValues('NoteCalendar') || null,
            EventAddress: getValues('EventAddress') ?? null,
            EventDistrictID: (getValues('EventDistrictID') == undefined ? 0 : getValues('EventDistrictID').SubdistrictId),
            EventZipCode: getValues('EventZipCode') ?? null,
            EventGPS: getValues('EventLocation') ?? null,
            InvoiceName: getValues('InvoiceName') ?? null,
            InvoiceTaxID: getValues('InvoiceTaxID') ?? null,
            InvoiceBranch: getValues('InvoiceBranch') ?? null,
            InvoiceAddress: getValues('InvoiceAddress') ?? null,
            InvoiceZipCode: getValues('InvoiceZipCode') ?? null,
        };
        try {
            const res = await API({ method: 'post', url: '/Quotation/Event', data: _ReqBody });
            if (!res.data.status) {
                Swal.fire({ icon: 'error', title: res.data.message || 'ไม่สามารถบันทึกวันจัดงานได้' });
                return;
            }
            setModalState(false);
            if (props.callback != undefined) {
                try { props.callback(); } catch (e) { }
            }
        } catch (e) {
            Swal.fire({ icon: 'error', title: 'การเชื่อมต่อผิดพลาด', text: e.message });
        }
    }
    return (
        <>
            <Modal isOpen={ModalState} className={'modal-xl'} centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">สร้างวันจัดงาน</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { _CloseModel() }}></button>
                </div>

                <div className='modal-body'>

                    <div className='mt-3 p-3 rounded border bg-light'>
                        <div className='row g-3'>
                            <div className="col-md-3">
                                <label className="form-label">วันที่จัดงาน</label>
                                <ThaiDatePicker
                                    minDate={moment().add(1, 'days').toDate()}
                                    inputProps={{ displayFormat: "DD/MM/YYYY", className: 'text-center form-control' }}
                                    value={(EventDate != undefined && EventDate != null ? EventDate : null)}
                                    onChange={(c) => { setEventDate(c); }} />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">เวลาถึงหน้างาน</label>
                                <div className="input-group">
                                    <select className="form-select text-center"
                                        value={_StandbyTime ? _StandbyTime.split(':')[0] : ''}
                                        onChange={(e) => {
                                            const m = _StandbyTime ? _StandbyTime.split(':')[1] : '00';
                                            setStandbyTime(e.target.value !== '' ? e.target.value + ':' + m : null);
                                        }}>
                                        <option value=''>HH</option>
                                        {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')).map(h => (
                                            <option key={h} value={h}>{h}</option>
                                        ))}
                                    </select>
                                    <span className="input-group-text px-1 fw-bold">:</span>
                                    <select className="form-select text-center"
                                        value={_StandbyTime ? _StandbyTime.split(':')[1] : '00'}
                                        onChange={(e) => {
                                            const h = _StandbyTime ? _StandbyTime.split(':')[0] : '00';
                                            setStandbyTime(h + ':' + e.target.value);
                                        }}>
                                        <option value='00'>00</option>
                                        <option value='15'>15</option>
                                        <option value='30'>30</option>
                                        <option value='45'>45</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">เวลาเริ่มบริการ</label>
                                <div className="input-group">
                                    <select className="form-select text-center"
                                        value={_StartTime ? _StartTime.split(':')[0] : ''}
                                        onChange={(e) => {
                                            const m = _StartTime ? _StartTime.split(':')[1] : '00';
                                            setStartTime(e.target.value !== '' ? e.target.value + ':' + m : null);
                                        }}>
                                        <option value=''>HH</option>
                                        {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')).map(h => (
                                            <option key={h} value={h}>{h}</option>
                                        ))}
                                    </select>
                                    <span className="input-group-text px-1 fw-bold">:</span>
                                    <select className="form-select text-center"
                                        value={_StartTime ? _StartTime.split(':')[1] : '00'}
                                        onChange={(e) => {
                                            const h = _StartTime ? _StartTime.split(':')[0] : '00';
                                            setStartTime(h + ':' + e.target.value);
                                        }}>
                                        <option value='00'>00</option>
                                        <option value='15'>15</option>
                                        <option value='30'>30</option>
                                        <option value='45'>45</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">เวลาสิ้นสุดบริการ</label>
                                <div className="input-group">
                                    <select className="form-select text-center"
                                        value={_EndTime ? _EndTime.split(':')[0] : ''}
                                        onChange={(e) => {
                                            const m = _EndTime ? _EndTime.split(':')[1] : '00';
                                            setEndTime(e.target.value !== '' ? e.target.value + ':' + m : null);
                                        }}>
                                        <option value=''>HH</option>
                                        {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')).map(h => (
                                            <option key={h} value={h}>{h}</option>
                                        ))}
                                    </select>
                                    <span className="input-group-text px-1 fw-bold">:</span>
                                    <select className="form-select text-center"
                                        value={_EndTime ? _EndTime.split(':')[1] : '00'}
                                        onChange={(e) => {
                                            const h = _EndTime ? _EndTime.split(':')[0] : '00';
                                            setEndTime(h + ':' + e.target.value);
                                        }}>
                                        <option value='00'>00</option>
                                        <option value='15'>15</option>
                                        <option value='30'>30</option>
                                        <option value='45'>45</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='row g-3 mt-2'>
                            <div className="col-md-3">
                                <label className="form-label">ชื่อผู้ติดต่อ</label>
                                <input type='text' className="form-control" placeholder="ชื่อผู้ติดต่อ" autoComplete="off" {...register("ContactName", { required: false })} />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">เบอร์โทร</label>
                                <input type='text' className="form-control" placeholder="เบอร์โทร" autoComplete="off" {...register("MobileMain", { required: false })} />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label">เบอร์โทร สำรอง</label>
                                <input type='text' className="form-control" placeholder="เบอร์โทร สำรอง" autoComplete="off" {...register("MobileBackup", { required: false })} />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label">ประเภท</label>
                                <select className='form-control text-center' value={AccountType} onChange={(e) => { setAccountType(e.target.value); if (Number(e.target.value) !== 1) setInvoice(0); }}>
                                    <option value={0}>เลือกประเภท</option>
                                    <option value={1}>บริษัท</option>
                                    <option value={2}>ร้าน</option>
                                </select>
                            </div>
                            <div className="col-md-2">
                                <label className="form-label">ใบกำกับภาษี</label>
                                <select className='form-control text-center' value={_Invoice} onChange={(e) => setInvoice(Number(e.target.value))}>
                                    <option value={1}>ต้องการ</option>
                                    <option value={0}>ไม่ต้องการ</option>
                                </select>
                            </div>
                        </div>
                        {_Invoice == 1 && <>
                            <div className='row g-3 mt-1'>
                                <div className="col-md-6">
                                    <label className="form-label">ชื่อธุรกิจ</label>
                                    <input type='text' className="form-control" placeholder="ชื่อธุรกิจ / หน่วยงาน / ชื่อบริษัท" autoComplete="off" {...register("InvoiceName", { required: false })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">เลขประจำตัวผู้เสียภาษี</label>
                                    <input type='text' className="form-control" placeholder="เลขประจำตัวผู้เสียภาษี" autoComplete="off" {...register("InvoiceTaxID", { required: false })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">สำนักงาน/สาขา</label>
                                    <input type='text' className="form-control" placeholder="สำนักงาน/สาขา" autoComplete="off" {...register("InvoiceBranch", { required: false })} />
                                </div>
                            </div>
                            <div className='row g-3 mt-1'>
                                <div className="col-md-10">
                                    <label className="form-label">ที่อยู่ (ใบกำกับภาษี)</label>
                                    <Controller name="InvoiceAddress" control={control} rules={{ required: false }} render={({ field }) => (
                                        <textarea rows={1} className="form-control" autoComplete="off" onChange={(e) => field.onChange(e)} defaultValue={field.value} />
                                    )} />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label">รหัสไปรษณีย์</label>
                                    <input type='text' maxLength={5} className="form-control text-center" placeholder="รหัสไปรษณีย์" autoComplete="off" {...register("InvoiceZipCode", { required: false })} />
                                </div>
                            </div>
                        </>}
                        <div className='row g-3 mt-1'>
                            <div className="col-md-4">
                                <label className="form-label">Facebook</label>
                                <Controller name="NoteFacebook" control={control} rules={{ required: false }} render={({ field }) => (
                                    <textarea rows={1} className="form-control" autoComplete="off" onChange={(e) => field.onChange(e)} defaultValue={field.value} />
                                )} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Line Chat</label>
                                <Controller name="NoteLine" control={control} rules={{ required: false }} render={({ field }) => (
                                    <textarea rows={1} className="form-control" autoComplete="off" onChange={(e) => field.onChange(e)} defaultValue={field.value} />
                                )} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Calendar</label>
                                <Controller name="NoteCalendar" control={control} rules={{ required: false }} render={({ field }) => (
                                    <textarea rows={1} className="form-control" autoComplete="off" onChange={(e) => field.onChange(e)} defaultValue={field.value} />
                                )} />
                            </div>
                        </div>
                        <hr className='my-2' />
                        <div className='row g-3 mt-1'>
                            <div className="col-md-4">
                                <label className="form-label">สถานที่จัดงาน (LocationDetail)</label>
                                <input type='text' className="form-control" placeholder="ชื่อ / รายละเอียดสถานที่จัดงาน" autoComplete="off"
                                    value={_LocationDetail} onChange={(e) => setLocationDetail(e.target.value)} />
                            </div>
                            <div className="col-md-8">
                                <label className="form-label">ที่อยู่สถานที่</label>
                                <Controller name="EventAddress" control={control} rules={{ required: false }} render={({ field }) => (
                                    <textarea rows={1} className="form-control" autoComplete="off" onChange={(e) => field.onChange(e)} defaultValue={field.value} />
                                )} />
                            </div>
                        </div>
                        <div className='row g-3 mt-1'>
                            <div className="col-md-5">
                                <label className="form-label">เขต</label>
                                <Controller name="EventDistrictID" control={control} rules={{ required: false }} render={({ field }) => (
                                    <AsyncSelect
                                        name={field.name}
                                        value={field.value}
                                        cacheOptions
                                        defaultOptions
                                        placeholder={'ค้นหา ตำบล / อำเภอ / จังหวัด'}
                                        loadOptions={(e) => SearchSubDistrict(e)}
                                        onChange={(e) => field.onChange(e)}
                                        getOptionLabel={(e) => e.FullName}
                                        getOptionValue={(e) => e.SubdistrictId} />
                                )} />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label">รหัสไปรษณีย์</label>
                                <input type='text' maxLength={5} className="form-control text-center" placeholder="รหัสไปรษณีย์" autoComplete="off" {...register("EventZipCode", { required: false })} />
                            </div>
                            <div className="col-md-5">
                                <label className="form-label">พิกัด GPS</label>
                                <div className="input-group">
                                    <input type='text' className="form-control" placeholder="lat, lon" readOnly
                                        {...register("EventLocation", { required: false })} />
                                    <button type="button" className="btn btn-outline-secondary" onClick={_OpenMapPicker}
                                        title="เลือกพิกัด">
                                        📍 เลือก
                                    </button>
                                    {watch('EventLocation') && (
                                        <a className="btn btn-outline-success"
                                            href={`https://www.google.com/maps?q=${watch('EventLocation')}`}
                                            target="_blank" rel="noreferrer" title="เปิด Google Maps">
                                            🗺️
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-12 d-flex justify-content-end gap-2'>
                                <button type="button" className='btn btn-primary' onClick={() => { _NewEvent(); }}>บันทึกวันจัดงาน</button>
                                <button type="button" className='btn btn-secondary' onClick={() => _CloseModel()}>ยกเลิก</button>
                            </div>
                        </div>
                    </div>

                </div>
            </Modal>
            {_MapPickerOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.55)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ background: '#fff', borderRadius: '8px', width: '660px', maxWidth: '96vw', maxHeight: '92vh', overflow: 'auto', boxShadow: '0 4px 24px rgba(0,0,0,.3)' }}>
                        <div className="p-3">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">📍 เลือกพิกัด GPS</h5>
                                <button type="button" className="btn-close" onClick={() => setMapPickerOpen(false)} />
                            </div>

                            {/* Lat / Lon inputs */}
                            <div className="row g-2 mb-2">
                                <div className="col-5">
                                    <label className="form-label small mb-1">ละติจูด (Latitude)</label>
                                    <input type="number" step="any" className="form-control"
                                        value={_PickerLat} onChange={e => setPickerLat(e.target.value)}
                                        placeholder="เช่น 13.756331" />
                                </div>
                                <div className="col-5">
                                    <label className="form-label small mb-1">ลองจิจูด (Longitude)</label>
                                    <input type="number" step="any" className="form-control"
                                        value={_PickerLon} onChange={e => setPickerLon(e.target.value)}
                                        placeholder="เช่น 100.501762" />
                                </div>
                                <div className="col-2 d-flex align-items-end">
                                    <button type="button" className="btn btn-outline-secondary w-100 text-nowrap"
                                        onClick={_GetCurrentLocation} title="ใช้ตำแหน่งปัจจุบัน">
                                        🎯 ปัจจุบัน
                                    </button>
                                </div>
                            </div>

                            {/* Paste Google Maps URL */}
                            <div className="mb-3">
                                <label className="form-label small mb-1">วาง Google Maps URL หรือ lat,lon</label>
                                <input type="text" className="form-control form-control-sm"
                                    placeholder="https://www.google.com/maps/@13.756331,100.501762,15z"
                                    onChange={e => _ParseMapsURL(e.target.value)} />
                            </div>

                            {/* Map preview */}
                            {_PickerLat && _PickerLon ? (
                                <div style={{ width: '100%', height: '340px', border: '1px solid #dee2e6', borderRadius: '4px', overflow: 'hidden', marginBottom: '12px' }}>
                                    <iframe
                                        key={`${_PickerLat},${_PickerLon}`}
                                        title="map-preview"
                                        width="100%" height="100%"
                                        frameBorder="0" style={{ border: 0 }}
                                        src={`https://maps.google.com/maps?q=${_PickerLat},${_PickerLon}&z=15&output=embed`}
                                        allowFullScreen />
                                </div>
                            ) : (
                                <div className="bg-light rounded d-flex align-items-center justify-content-center mb-3"
                                    style={{ height: '340px', border: '1px dashed #ced4da', color: '#adb5bd', fontSize: '14px' }}>
                                    กรอกละติจูด / ลองจิจูด เพื่อดูแผนที่
                                </div>
                            )}

                            <div className="d-flex justify-content-end gap-2">
                                <button type="button" className="btn btn-secondary" onClick={() => setMapPickerOpen(false)}>ยกเลิก</button>
                                <button type="button" className="btn btn-primary"
                                    disabled={!_PickerLat || !_PickerLon}
                                    onClick={_ConfirmLocation}>
                                    บันทึกพิกัด
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
});

export default React.memo(QuotationEventCreate)
